module.exports = __webpack_public_path__ + "static/media/airBaltic-club-logo.7192310b.svg";